import React from "react";
import { StyleSheet, View } from "react-native";
import CustomText from "../../../common/general/CustomText/CustomText";
import { colors, spacing, typographyScale } from "../../../../styles/design-system";

export interface SubjectiveCardProps {
  /** Reflection prompt; learner replies via the main composer — routing is handled by the backend. */
  question: string;
}

/** Visual parity with axiodesignsystem `ReflectionContainer` (ile-v2). */
export const SubjectiveCard = ({ question }: SubjectiveCardProps) => {
  return (
    <View style={styles.outer} accessible accessibilityLabel={`Question for you: ${question}`}>
      <View style={styles.reflectionStrip}>
        <CustomText
          useTranslationText={false}
          text="Question for you"
          size="s"
          weight="medium"
          style={styles.reflectionLabel}
        />
        <CustomText useTranslationText={false} text={question} size="s" weight="normal" style={styles.reflectionBody} />
      </View>
    </View>
  );
};

const REFLECTION_MAX_WIDTH = 672;

const styles = StyleSheet.create({
  outer: {
    width: "100%",
    maxWidth: REFLECTION_MAX_WIDTH,
    marginTop: spacing.none,
    marginBottom: spacing.sm,
  },
  reflectionStrip: {
    borderLeftWidth: 2,
    borderLeftColor: colors.accent.ocean300,
    paddingLeft: spacing.md,
    paddingVertical: spacing.xxs,
  },
  reflectionLabel: {
    color: colors.accent.ocean600,
    marginBottom: spacing.xs,
    fontSize: typographyScale.textSm.fontSize,
    lineHeight: typographyScale.textSm.lineHeight,
  },
  reflectionBody: {
    color: colors.grey[800],
    fontSize: typographyScale.textBase.fontSize,
    lineHeight: 24,
  },
});
